export default __webpack_public_path__ + "static/dolomite-whitepaper-image-18148ebb606e8ab5a152d0cdc16f9470.svg";